import SetSaleBillBottom from "../saleBill/SetSaleBillBottom";
import SetSaleBillMiddle from "../saleBill/SetSaleBillMiddle";
import SetSaleBillTop from "../saleBill/SetSaleBillTop";
import AddonsTable from "../saleBill/AddonsTable";
import BillTotals from "../saleBill/BillTotals";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { useBill } from "hooks/bill";
import { useEffect } from "react";
import useFullScreenLayout from "hooks/useFullScreenLayout";
import { useOneShippingInfo } from "http-hooks/shippinginfo/useShippinginfo";
import Loading from "components/Loading";

export default function SetShippingInfo() {
  useFullScreenLayout();

  const {id} = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Fetch shipping info data for edit mode
  const { data: shippingInfoData, isLoading: isLoadingShippingInfo } = useOneShippingInfo(id, { 
    enabled: !!id,
    refetchOnWindowFocus: false,
  });
  
  // Get all bill state and data
  const {
    billHeader,
    tableData,
    totalGross,
    totalTax,
    totalQty,
    totalQtyPcs,
    docType,
    traderBillType,
    selectBoxes,
    createShippingInfo,
    updateShippingInfo,
    isCreatingShippingInfo,
    isUpdatingShippingInfo,
    populateShippingInfoForEdit,
    resetStore,
  } = useBill();

  // Reset store when component mounts or id changes (prevents stale data from edit → create navigation)
  useEffect(() => {
    resetStore();
  }, [id, resetStore]);

  // Populate form when shipping info data is loaded (edit mode)
  useEffect(() => {
    if (shippingInfoData && id) {
      populateShippingInfoForEdit(shippingInfoData);
    }
  }, [shippingInfoData, id, populateShippingInfoForEdit]);

  const handleSubmitForm = async () => {
    // Prepare structured data for API
    const structuredData = {
      billHeader,
      tableData: tableData.filter(item => item.selected), // Only selected items
      docType: "PL",
      traderbilltyp: traderBillType,
      calculations: {
        totalQty,
        totalQtyPcs,
        totalGross,
        totalTax
      }
    };

    // Log structured data
    console.log("=== STRUCTURED SHIPPING INFO DATA ===");
    console.log("1. Bill Header:", structuredData.billHeader);
    console.log("2. Selected Items:", structuredData.tableData);
    console.log("3. Document Type:", structuredData.docType);
    console.log("4. Trader Bill Type:", structuredData.traderbilltyp);
    console.log("5. Calculations:", structuredData.calculations);
    console.log("=== READY TO SEND TO API ===");
    
    try {
      // Call create or update based on whether id exists
      if (id) {
        await updateShippingInfo({ id, data: structuredData });
      } else {
        await createShippingInfo(structuredData);
      }
      // Navigate to shipping info listing page after successful creation/update
      navigate(`/shippinginfo${location.search}`);
    } catch (error) {
      console.error("Error saving shipping info:", error);
      // Error toast is handled in the service
    }
  };

  // Show loading state while fetching shipping info for edit
  if (id && isLoadingShippingInfo) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loading />
      </div>
    );
  }

  return (
    <form>
      <div className="space-y-8 px-4 sm:px-6 lg:px-8">
        <SetSaleBillTop id={id} docType={"PL"} />
        <SetSaleBillMiddle docType="PL" />
        {selectBoxes.billType?.value === "ORD" && (
          <AddonsTable docType="PL" />
        )}
        <BillTotals docType="PL" />
        <SetSaleBillBottom
          totalGross={totalGross}
          totalTax={totalTax}
          docType={"PL"}
          handleSubmitForm={handleSubmitForm}
          isSubmitting={id ? isUpdatingShippingInfo : isCreatingShippingInfo}
        />
      </div>
    </form>
  );
}
